<template>
    <div>
        <div
            v-for="grupo in gruposComProdutos"
            :key="grupo.descricao"
            class="grupo-section"
        >
            <div
                class="category mt-4 mb-2"
                :style="isDark ? 'color: #ccc;' : 'color: #555555;'"
                :id="grupo.descricao.replace(/\s/g, '-')"
            >
                {{ grupo.descricao }}
            </div>

            <div class="products-grid">
                <v-card
                    v-for="(item, index) in grupo.produtos"
                    :key="index"
                    @click="$emit('abrir', item)"
                    class="product-card"
                    elevation="8"
                    tile
                    :style="estiloCard(item)"
                >
                    <div class="product-img-wrapper">
                        <v-img
                            v-if="imagensProntas"
                            :src="getUrl(item.imagem)"
                            class="product-img"
                        />
                        <div
                            v-if="configuracoes.exibir_estoque_cardapio && item.controle_estoque && item.estoque > 0"
                            class="stock-chip"
                        >
                            <span class="caption">{{ getEstoqueText(item) }}</span>
                        </div>
                    </div>

                    <div class="product-content">
                        <div class="px-2 pt-2 pb-1">
                            <div
                                class="product-title"
                                :style="`color: ${isDark ? '#fff' : '#555'};`"
                            >
                                {{ item.descricao }}
                            </div>
                            <div
                                class="mt-1"
                                :style="`color: ${isDark ? '#d2d2d2' : '#444'}`"
                            >
                                <span class="product-details">{{ item.detalhes }}</span>
                            </div>
                        </div>

                        <div
                            v-if="item.pontos_ativo && fidelidade.resgate_ativo"
                            class="px-2 mt-1"
                        >
                            <v-chip
                                color="green lighten-5"
                                text-color="green"
                                small
                                style="font-size: 11px; font-weight: bold;"
                            >
                                {{ $t('produto.resgatePor', { n: Math.round((+item.valor || item.valor_minimo) * item.pontos_multiplicador) }) }}
                            </v-chip>
                        </div>

                        <div v-if="getValor(item)" class="px-2 pb-3 mt-2">
                            <div v-if="+item.valor_antigo" class="mb-1">
                                <v-chip color="green" text-color="white" class="mr-1" label x-small>
                                    {{ getDiscount(item) }}%
                                </v-chip>
                                <span style="text-decoration: line-through; font-size: 13px; font-weight: bold; color: #757575;">
                                    {{ formatMoney(+item.valor_antigo) }}
                                </span>
                            </div>
                            <div>
                                <span style="color: #4CAF50; font-weight: bold; font-size: 17px;">
                                    {{ getValor(item) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="item.pontos_ativo && fidelidade.resgate_ativo && item.valor"
                        style="position: absolute; top: -5px; right: -5px; display: flex;"
                    >
                        <v-btn fab width="32" height="32" color="primary" readonly>
                            <v-icon small color="white">mdi-gift-outline</v-icon>
                        </v-btn>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { clone, normalizarBusca } from '@/utils/utils';
import { esgotado } from '@/utils/estoque';

export default {
    name: 'ProdutosGrade',

    props: {
        search: {
            type: String,
            default: '',
        },
        imagensProntas: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapState([
            'produtos',
            'grupos',
            'configuracoes',
        ]),

        isDark() {
            return this.$vuetify.theme.isDark;
        },

        fidelidade() {
            return this.configuracoes.fidelidade || {};
        },

        gruposComProdutos() {
            const termo = normalizarBusca(this.search);

            return clone(this.grupos)
                .sort((a, b) => (+a.ordem > +b.ordem) ? 1 : ((+b.ordem > +a.ordem) ? -1 : 0))
                .map(grupo => ({
                    descricao: grupo.descricao,
                    produtos: this.produtos.filter(p =>
                        p.grupo.descricao === grupo.descricao
                        && normalizarBusca(p.descricao).includes(termo)
                    ),
                }))
                .filter(grupo => grupo.produtos.length);
        },
    },

    methods: {
        estiloCard(item) {
            return {
                'border': `solid 1px ${this.isDark ? '#505050' : '#c1c1c1'}`,
                'border-radius': '10px !important',
                'background-color': `rgb(${this.isDark ? '21 21 21' : '250 250 250'} / 60%) !important`,
                'opacity': this.estoqueDisponivel(item) ? '1' : '0.3',
                'overflow': 'hidden',
            };
        },

        estoqueDisponivel(produto) {
            return !esgotado(produto);
        },

        getValor(produto) {
            return this.estoqueDisponivel(produto)
                ? (+produto.valor_minimo ? this.$t('produto.aPartirDe', { valor: this.formatMoney(produto.valor_minimo) }) : (+produto.valor ? `${this.formatMoney(produto.valor)}` : ''))
                : this.$t('produto.esgotadoCaixaAlta');
        },

        getEstoqueText(item) {
            return item.estoque > 1
                ? this.$t('produto.restamUnidades', { n: item.estoque })
                : this.$t('produto.restaUma');
        },

        getDiscount(item) {
            const preco = item.valor_minimo || item.valor;
            const descontoPercentual = ((item.valor_antigo - preco) / item.valor_antigo) * 100;
            return Math.round(descontoPercentual);
        },

        getUrl(img) {
            if (!img?.url) {
                return require('@/assets/noimageavailable.png');
            }

            return img.tmp
                ? `${this.$urlAPI}/files/tmp/${img.url}`
                : `${this.$urlAPI}/storage/${img.url}`;
        },
    },
};
</script>

<style scoped>
.category {
    font-size: 1.3em;
    font-weight: 700;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.grupo-section {
    margin-bottom: 4px;
}

.products-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    padding: 8px 0 16px;
}

@media (min-width: 960px) {
    .products-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 18px;
    }
}

@media (min-width: 1400px) {
    .products-grid {
        grid-template-columns: repeat(4, 1fr);
        gap: 18px;
    }
}

.product-card {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    position: relative;
}

.product-img-wrapper {
    height: 150px;
    overflow: hidden;
    position: relative;
    border-radius: 10px 10px 0 0;
}

@media (min-width: 600px) {
    .product-img-wrapper {
        height: 190px;
    }
}

.product-img {
    width: 100% !important;
    height: 100% !important;
}

.product-content {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.product-title {
    text-transform: uppercase;
    letter-spacing: 1px;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    line-height: 1.2;
    font-weight: bold;
    font-size: 14px;
}

.product-details {
    -webkit-text-size-adjust: 100%;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 13px;
    line-height: 18px;
    white-space: pre-line;
}

.stock-chip {
    position: absolute;
    top: 0;
    background: #8009e5;
    color: white;
    border-radius: 5px;
    padding: 0 5px;
}
</style>
